import { Brand } from "@/components/layout/Brand";
import { NavLinks } from "@/components/layout/NavLinks";
import { MobileMenu } from "@/components/layout/MobileMenu";
import { BuyButton } from "@/components/BuyButton";
import { STORE } from "@/constants/testIds";

export const Navbar = () => (
  <header
    data-testid={STORE.nav}
    className="sticky top-0 z-50 border-b border-[color:rgba(231,190,74,0.14)] bg-[color:rgba(7,20,39,0.92)] backdrop-blur supports-[backdrop-filter]:bg-[color:rgba(7,20,39,0.80)]"
  >
    <nav className="mx-auto flex min-h-16 max-w-6xl items-center gap-4 px-4 py-2 sm:px-6 lg:px-8">
      <Brand />
      <NavLinks />
      <div className="hidden shrink-0 xl:block">
        <BuyButton
          label="Get full access — $79"
          testId={STORE.navPrimaryCta}
          size="sm"
          className="whitespace-nowrap"
        />
      </div>
      <MobileMenu />
    </nav>
  </header>
);

export default Navbar;
